import { createReducer, on } from "@ngrx/store";
import { marketDataModel } from "@sports-models/index";
import * as SportsbookActions from "../../../stores/sportsbook/sportsbook.actions";

export const initialState: marketDataModel = {
  categories: [],
  marketBets: [],
  leagueName: "",
  market: null,
  parentId: "",
  selectedCategory: null,
  betsenseData: null,
};

export const SportsbookMarketReducer = createReducer(
  initialState,
  // MarketPage
  on(SportsbookActions.setMarkets, (state, marketData) => ({
    ...state,
    ...marketData,
  })),
  on(SportsbookActions.clearMarkets, (state) => ({
    ...state,
    ...initialState,
  })),
);
